// Labels shared by the payout-account blocks (Paystack plan PR 7a).

export const formatDateTime = (iso) => (iso
  ? new Date(iso).toLocaleString('en-ZA', { timeZone: 'Africa/Johannesburg', day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })
  : 'Unknown');

export const ENV_LABEL = { simulation: 'Simulation', test: 'Paystack test', live: 'Paystack live', null: 'Not checked' };

export const REVIEW_LABEL = {
  validating: 'Bank check running',
  checked: 'Bank check passed, waiting for approval',
  manual_review: 'Manual review: needs a bank letter',
  approved: 'Approved',
};

export const OUTCOME_LABEL = {
  passed: 'Passed',
  failed: 'Did not pass',
  unavailable: 'Could not run',
  not_supported: 'The bank cannot check this account type',
};

export const BLOCK_LABEL = {
  none: 'Not created',
  validating: 'Live bank check running',
  creating: 'Creating at Paystack',
  created: 'Created, waiting for verification at Paystack',
  verified: 'Verified in Paystack',
  manual_review: 'Needs an admin',
  suspended: 'Suspended',
};

export const LETTER_LABEL = { pending: 'Waiting for review', verified: 'Accepted', rejected: 'Rejected' };

export const yesNo = (value) => (value === true ? 'yes' : value === false ? 'no' : 'not known');

export const errorText = (err, fallback) => err?.response?.data?.message || err?.message || fallback;
